import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../components/controls/FormInput";
import DropdownMenu from "../../components/controls/DropdownMenu";
import Button from "../../components/controls/Button";

export default function CitySelector({ value, onChange }) {
  const { t } = useTranslation();
  const [cities, setCities] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await fetch("/geojson/simplified_cities.json");
        const data = await res.json();

        const sorted = data
          .filter((c) => c.nameFr || c.nameEn)
          .sort((a, b) =>
            (a.nameFr || a.nameEn).localeCompare(b.nameFr || b.nameEn)
          );

        setCities(sorted);

        const selected = sorted.find((city) => city.id === value);
        if (selected) setSearch(selected.nameFr || selected.nameEn);
        if (!selected && value == null) setSearch("");
      } catch (err) {
        console.error("Erreur chargement villes", err);
      }
    };

    fetchCities();
  }, [value]);

  const selectedLabel = useMemo(() => {
    const selected = cities.find((c) => c.id === value);
    return selected
      ? selected.nameFr || selected.nameEn
      : t("global.selectCity");
  }, [cities, value, t]);

  const filtered = useMemo(() => {
    const q = (search || "").toLowerCase().trim();
    if (!q) return cities;
    return cities.filter((city) =>
      (city.nameFr || city.nameEn || "").toLowerCase().includes(q)
    );
  }, [cities, search]);

  const items = useMemo(
    () =>
      filtered.map((city) => ({
        label: city.nameFr || city.nameEn,
        onClick: () => {
          onChange(city.id);
          setSearch(city.nameFr || city.nameEn);
        },
      })),
    [filtered, onChange]
  );

  const clearSelection = () => {
    onChange(null);
    setSearch("");
  };

  return (
    <div className="w-full max-w-xs text-primary">
      <div className="mb-2">
        <span className="font-semibold">{t("global.city")}</span>
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <DropdownMenu
            title={selectedLabel}
            items={items}
            isDropdown
            withSearch
            searchPlaceholder={t("global.search") || "Rechercher..."}
          />

          {search !== "" && (
            <Button type="button" size="sm" onClick={clearSelection}>
              {"Effacer"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
